import { isVariant, MarketType } from '@drift-labs/sdk';
import Env from 'src/environmentVariables/EnvironmentVariables';
import useDriftStore from 'src/stores/DriftStore/useDriftStore';
import useDriftClientIsReady from './useDriftClientIsReady';

const useMarketMaxLeverage = (marketType: MarketType, marketIndex: number) => {
	const driftClient = useDriftStore((s) => s.driftClient.client);
	const driftClientIsReady = useDriftClientIsReady();

	if (!driftClientIsReady) return;

	if (isVariant(marketType, 'perp')) {
		const marketAccount = driftClient.getPerpMarketAccount(marketIndex);

		return parseFloat(
			(
				1 /
				((marketAccount?.marginRatioInitial
					? marketAccount?.marginRatioInitial
					: 10000 / Env.defaultMaxMarketLeverage) /
					10000)
			).toFixed(2)
		);
	} else {
		const marketAccount = driftClient.getSpotMarketAccount(marketIndex);

		const liabilityWeight = marketAccount.initialLiabilityWeight / 10000;

		return parseFloat((1 / (liabilityWeight - 1)).toFixed(2));
	}
};

export default useMarketMaxLeverage;
